import firebase from 'firebase/compat/app';
import STORE_CONSTANTS from '../constants';

const converter = {
  toFirestore(
    program: BonusTypes.BonusProgram,
  ): firebase.firestore.DocumentData {
    return program;
  },
  fromFirestore(
    snapshot: firebase.firestore.QueryDocumentSnapshot<BonusTypes.BonusProgram>,
    options: firebase.firestore.SnapshotOptions,
  ): BonusTypes.BonusProgram {
    const data = {
      ...snapshot.data(options),
    };

    return data;
  },
};

const getBonusProgramsRef = ({
  accountId,
  db,
}: {
  accountId: string;
  db?: firebase.firestore.Firestore;
}) => {
  return (db ? db : firebase.firestore())
    .collection('accounts')
    .doc(accountId)
    .collection(STORE_CONSTANTS.DRIVER_BONUS_COLLECTION)
    .withConverter(converter);
};

export default getBonusProgramsRef;
